// extracted by mini-css-extract-plugin
export default {"footerContainer":"styles_footerContainer__6zXbh","footer":"styles_footer__rCett","card":"styles_card__Oyyn8","rights":"styles_rights__kv35y"};